const initialState = {
  userId: null,
  mode: 'light',
  globalLoader: false,
};

export const SET_USER_ID = 'SET_USER_ID';
export const SET_MODE = 'SET_MODE';
export const SET_GLOBAL_LOADER = 'SET_GLOBAL_LOADER';

export const setUserId = (userId) => ({ type: SET_USER_ID, payload: userId });
export const setMode = (mode) => ({ type: SET_MODE, payload: mode });
export const setGlobalLoader = (globalLoader) => ({
  type: SET_GLOBAL_LOADER,
  payload: globalLoader,
});

const globalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_ID:
      return { ...state, userId: action.payload };
    case SET_MODE:
      return { ...state, mode: action.payload };
    case SET_GLOBAL_LOADER:
      return { ...state, globalLoader: action.payload };
    default:
      return state;
  }
};

export default globalReducer;
